module.exports = __webpack_public_path__ + "static/media/Appraisal.d73fb49f.png";